import { FC, Fragment, useContext, useEffect, useRef, useState } from "react";
import PracticeContactInfo from "src/components/practiceContactInfo";
import ReactPaginate from "react-paginate";

import { SPECIALITY_MANUFACTURE_PHARMACY, SPECIALITY_PHARMACY } from "src/constants/todos";
import { ActionDashboardActionType, ActionDashboardStateActions, sp_treatments_data, SpecialityPharmacyCompProps } from "./types";
import { ActionStatisticsDashboardActionType, PatientFilterStateActions } from "../manufacturer/actionDashboard/types";
import { AuthContext } from "src/context/authContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";
import ConfirmIndication from "src/components/modals/confirmIndication";
// import { APIEndpoints } from "src/types/apiTypes";
// import useFetch from "src/hooks/useFetch";
// import { ToastContext } from "src/context/toastContext";
// import { LoaderContext } from "src/context/loaderContext";
// import { ToastTypes } from "src/types";
import AddNote from "src/components/modals/addNote";
import ReRunPatientModal from "src/components/modals/rerunPatientModal";
import { handleNavigation, isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import { ColumnSortProps } from "src/components/tableHeader/types";
import { sortTableColumns } from "src/helpers/stats";
import TableHeader from "src/components/tableHeader";

const SpecialityPharmacy: FC<SpecialityPharmacyCompProps> = ({ tableData, currentPage, onPageChange, onActionPerformed }): JSX.Element => {
  const [spTreatmentListing, updateSpTreatmentListing] = useState<sp_treatments_data[]>([]);
  const [sortingConfig, setSortingConfig] = useState<ColumnSortProps>({
    sort_by: '',
    direction: 'desc',
  });

  const { isManufacturer, defaultView,userData } = useContext(AuthContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
    isModalVisible: false,
    caseId: 0,
  });
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number; bentype: string; investigated_at?: string }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    bentype: "",
    investigated_at: ""
  });

  const [showCancelIndicationModal, setDataForCancelIndication] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [showReRunPatientModal, setShowReRunPatientModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number, title: string, bentype: string; investigated_at?: string; }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    title: '',
    bentype: ""
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rowindex, setIndex] = useState<number>();
  const [pageSearch, setPageSearch] = useState(currentPage.toString());

  useEffect(() => {
    updateSpTreatmentListing(tableData?.sp_treatments_data ?? [])
    if (tableData?.sp_treatments_data) {
      setSortingConfig({ direction: "desc", sort_by: "" })
    }
  }, [tableData])

  const changePageNumber = (page: { selected: number }) => {
    if (isManufacturer) {
      const action: ActionStatisticsDashboardActionType = {
        type: PatientFilterStateActions.CHANGE_SP_TREATMENT_PAGE,
        payload: page.selected + 1,
      };
      onPageChange(action as never);
    } else {
      const action: ActionDashboardActionType = {
        type: ActionDashboardStateActions.CHANGE_SP_TREATMENT_PAGE,
        payload: page.selected + 1,
      };
      onPageChange(action as never);
    }
      setPageSearch((page.selected + 1).toString())

  };
  // const { showToast } = useContext(ToastContext);
  // const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  // const { loading: transferRxLoading, data: transferRxData } =
  //   useFetch(APIEndpoints.TRANSFER_RX,);

  // useEffect(() => {
  //   if (transferRxData) {
  //     const { message } = transferRxData as unknown as { code: number; message: string; };
  //     showToast([message], ToastTypes.SUCCESS);
  //     // getCaseListing();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxData]);

  // useEffect(() => {
  //   if (transferRxLoading) setLoader();
  //   else hideLoader();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxLoading]);

  // const ConfirmAlert = (title: string, buttonName: string, caseId: number) => {

  //   const result = window.confirm(title);
  //   if (result) {
  //     // if(buttonName === 'xFerToSP'){
  //     transferRxByCaseId({}, { caseId: caseId, rep_xfer: true })
  //     // }
  //     // else if (buttonName === "patientPurchase"){
  //     //   transferRxByCaseId({case_id:caseId,pdp:1},{case_id:caseId,pdp:1})
  //     // }
  //   }
  // };
  const navigateToModalAndPage = (item: sp_treatments_data) => {
    if (item.re_run_type === 'popup') {
      setShowReRunPatientModal({ caseId: item.bi_case_id, isModalVisible: true, prescriptionId: item.prescription_id, title: "Please update case status below", bentype: "med", investigated_at: item.investigated_at ?? undefined })
    } else {
      navigate(`/cases/${item ? item.bi_case_id : 0}/clone`)
    }
  }
  const handlePageSearch = () => {
  const pageNumber = Number(pageSearch);

  if (!tableData?.page_count) return;

  if (!pageNumber || pageNumber < 1 || pageNumber > tableData.page_count) {
    // optionally reset input to current page
    setPageSearch(currentPage.toString());
    return;
  }

  // Trigger page change
  changePageNumber({ selected: pageNumber - 1 });

  // Update input to formatted value
    setPageSearch(pageNumber.toString());
};
  const redirectDecision = () => {
    const isRedirectRequired =  handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0)
    }
  }

  const changeIdOrder = (value: string) => {
    sortTableColumns(value, sortingConfig, setSortingConfig, spTreatmentListing, updateSpTreatmentListing)
  };


  return (
    <Fragment>
      <div className="table-responsive overflow-auto" style={{ maxHeight: "600px" }}>
        <table className="table table-striped table-sm mb-0">
          <thead className="sticky-top" style={{ zIndex: '500' }}>
            <tr className="text-center align-items-center">
              {isManufacturer === false ?
                SPECIALITY_PHARMACY.map((tableHeader, index) => (
                  <TableHeader
                    key={index}
                    tableHeader={{ 
                      ...tableHeader, 
                      width: tableHeader.width ? `${tableHeader.width}%` : "" 
                    }}
                    sortConfig={sortingConfig}
                    classNames={`${tableHeader.label === "Pharmacy (SP) Status" ? " border border-2 border-top-0 border-bottom-0 border-start border-dark user-select-text" : "user-select-text"}`}
                    changeIdOrder={changeIdOrder}
                  />
                ))
                :
                SPECIALITY_MANUFACTURE_PHARMACY.map((tableHeader, index) => (
                  (tableHeader.label === "FAM/Office Note" && userData && userData.ref_type === "rep") ?
                    <></>
                    :
                    <TableHeader
                      key={index}
                      tableHeader={{
                        ...tableHeader,
                        width: tableHeader.width ? `${tableHeader.width}%` : ""
                      }}
                      sortConfig={sortingConfig}
                      classNames={`${tableHeader.label === "Pharmacy (SP) Status" ? " border border-2 border-top-0 border-bottom-0 border-start border-dark user-select-text" : "user-select-text"}`}
                      changeIdOrder={changeIdOrder}
                    />
                  )
                )
              }
            </tr>
          </thead>

          <tbody>
            {spTreatmentListing.length > 0 ?
              spTreatmentListing.map((data, index) => {
                const isOffice = data.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "office"
                const isFam = data.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "fam"
                return(
                <tr key={index}>
                  {data.patient_name !== 'Redacted' ?
                    <td className="text-center align-middle">
                      <Link to={`/global_patients/${data.patient_id}/edit`}>
                        {data.patient_name}
                      </Link>

                    </td>
                    :
                    (
                      <td className="text-black text-center align-middle">
                        {data.patient_name}
                      </td>
                    )
                  }
                  <td className="text-center align-middle">
                    <Link to={`/global_patients/${data.patient_id}/edit`}>
                      {data.patient_id}
                    </Link>
                  </td>
                  <td className="text-center align-middle">
                    {isManufacturer ? (
                      data.indication.toLowerCase() === 'other' ?
                        <p className="fw-bold text-danger mb-0">{data.bi_case_id}</p> :
                        <Link to={`/cases/${data.bi_case_id}`}>
                            {data.message_icon && !isManufacturer && <i className="fas fa-comment me-1"></i>}{data.bi_case_id}
                        </Link>
                    ) : (
                      <Link to={`/cases/${data.bi_case_id}`}>
                          {data.message_icon && !isManufacturer && <i className="fas fa-comment me-1"></i>}{data.bi_case_id}
                      </Link>
                    )}
                  </td>
                  <td className="text-center align-middle">
                    <PracticeContactInfo
                      name={data.practice_name} 
                      address={data.practice_full_address} 
                      phone={data.practice_phone_number ?? ""} 
                      fax={data.practice_fax_number ?? ""}
                      indexKey={index}
                    >
                      <>
                        {typeof data.provider === "boolean" && data.provider ? (
                          <button type="button" className="btn btn-green">{data.provider}</button>
                        ) : typeof data.provider === "string" && <span>{data.provider}</span>}
                      </>
                    </PracticeContactInfo>
                  </td>
                  <td className="text-center align-middle">
                    {isManufacturer ? data.sp_transferred_to : data.sp_transfered_to
                      //&& format(data.sp_transferred_to, "dd/MM/yyyy")
                    }
                  </td>
                  <td className="text-center align-middle">
                    {data.date_transferred
                      //&& format(data.date_transferred, "dd/MM/yyyy")
                    }
                  </td>
                  <td className="text-center align-middle">
                    {data && data.status_update && data.status_update.status && <span data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      title={data && data.status_update && data.status_update.status}
                    >
                      {isMobileOrTablet() ? 
                        <i
                          className="bi bi-exclamation-circle-fill fa-lg info-icon ms-2"
                          id={`case_patient_toolTip-${index}`}
                          onClick={() => changeInfoIconIndex(infoIconIndex !== index ? index : -1)}
                          ref={toggleIconRef}
                          style={{
                            color: data.status_update.color === "yellow" ? 
                              '#f2ba45' : data.status_update.color === "green" ? 
                                "#3b8657" : data.status_update.color === "red" ? "#de5466" : "white"
                          }}
                        >
                          <div
                            className={`info-icon-detail bg-dark ${infoIconIndex === index ? "d-block" : "d-none"}`}
                            dangerouslySetInnerHTML={{
                              __html: `<p class="m-0 text-start">${data && data.status_update && data.status_update.status}</p>`
                            }}
                          ></div>
                        </i>
                        :
                        <i className="fas fa-info-circle fa-lg text-color-yellow"
                          style={{
                            color: data.status_update.color === "yellow" ? 
                              '#f2ba45' : data.status_update.color === "green" ? 
                                "#3b8657" : data.status_update.color === "red" ? "#de5466" : "white"
                          }}
                        ></i>
                      }
                      {/* {isManufacturer ? data.status_update.status : data.status_update.status} */}
                    </span>}

                  </td>
                  <td className="text-center align-middle">
                    {isManufacturer ? data.date_shipped : data.date_shipped}
                  </td>
                  <td className="text-center align-middle">
                    {data.carrier}
                  </td>
                  <td className="text-center align-middle">
                    {data.tracking_number}
                  </td>
                  <td 
                    className={`text-center text-white align-middle status-borders fw-bold background-color-${data.pharmacy_sp_status_color}`}
                    id='pharmacy_sp_status_color'
                    title={data.pharmacy_coverage_tooltip}
                    data-bs-toggle="tooltip"
                  >
                    {data.pharmacy_sp_status}
                  </td>
                  {/* <td className={`text-center align-middle fs-6 border border-1 border-end-0 border-top-0 border-bottom-0 border-start border-dark`} id='medical_provide_treatment_status'>
                   
                   {data.pharmacy_sp_status}
                 </td> */}
                  <td className="text-center align-middle" id="next-steps">
                    {/* //{Object.hasOwn(data, "indication") && data.indication.toLowerCase() === "other" ? <span className="text-black">No Action Required</span> : null} */}
                    {data['next_steps'] ?
                      data['next_steps']?.map((step, index) => {
                        // {data?.medical_next_steps?.map((step, index) => {
                        if (step === "Treated") {
                          return (
                            <button key={index} className="btn btn-green btn-sm rounded-0 m-1" type="button"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "med", investigated_at: data.investigated_at || "" })}
                            >
                              <i className="far fa-clipboard"></i> Treated
                            </button>
                          );
                        }

                        else if (step === "Treatment Scheduled") {
                          return (
                            <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                              type="button">

                              <i className="fas fa-times"></i> Treatment Scheduled
                            </button>
                          );
                        }
                        else if (step === "Schedule") {
                          return (
                            <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "non" })}
                              type="button">

                              <i className="fas fa-times"></i> Schedule
                            </button>
                          );
                        }

                        else if (step === "Not Treating") {
                          return (
                            <button key={index} onClick={() => setDataForCancelModal({ caseId: data.bi_case_id, isModalVisible: true, prescriptionId: data?.prescription_id })} className="btn btn-green btn-sm rounded-0 m-1" type="button">
                              <i className="fas fa-times"></i> Not Treated
                            </button>
                          );
                        }
                        else if (step === "Not Treated") {
                          return (
                            <button key={index} onClick={() => setDataForCancelModal({ caseId: data.bi_case_id, isModalVisible: true, prescriptionId: data?.prescription_id })} className="btn btn-green btn-sm rounded-0 m-1" type="button">
                              <i className="fas fa-times"></i> Not Treated
                            </button>
                          );
                        }
                        else if (step.includes("Scheduled Tx Date")) {
                          return (
                            <button key={index} className="btn btn-link m-1 user-select-text"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                              type="button">
                              {step}
                            </button>
                          );

                        }
                        
                        else if (step === "No Action Required") 
                          return (
                            <p className="text-black">No Action Required</p>
                          );
                        // switch (step) {
                        //   case "Treated":
                        //     return (
                        //       <button key={index} className="btn btn-success rounded-0 m-1"
                        //        type="button"
                        //        onClick={()=> setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id,prescriptionId:data.prescription_id,bentype:"" })}
                        //        >
                        //         <i className="bi bi-clipboard"></i> Treated
                        //       </button>
                        //     );
                        //     // case "Not Treating":
                        //     //   return (
                        //     //     <button key={index} className="btn btn-success rounded-0 m-1" 
                        //     //     onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id })}

                        //     //     type="button">
                        //     //       <i className="bi bi-x-lg"></i> Not Treating
                        //     //     </button>
                        //     //   );
                        //       case "Treatment Scheduled":
                        //         return (
                        //           <button key={index} className="btn btn-success background-color-3 rounded-0 m-1"
                        //             onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "non" })}
                        //             type="button">

                        //             <i className="bi bi-x-lg"></i> Schedule
                        //           </button>
                        //         );
                        //     case "Not Treated":
                        //       return (
                        //         <button key={index} className="btn btn-success rounded-0 m-1" 
                        //         onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id})}

                        //         type="button">
                        //           <i className="bi bi-x-lg"></i> Not Treating
                        //         </button>
                        //       );
                        // case "Transferred":
                        //   return (
                        //     <button key={index} className="btn btn-success rounded-0 m-1" 
                        //     onClick={() => ConfirmAlert('By clicking this you are noting the office has transferred this prescription to a Specialty Pharmacy. Are you sure you want to mark this prescription transferred? This cannot be undone!',"xFerToSP",data.bi_case_id)}
                        //     type="button">
                        //       <i className="bi bi-x-lg"></i> Transferred
                        //     </button>
                        //   );
                        // case "Precert":
                        //   return (
                        //     <button key={index} className="btn background-color-5 border border-1 border-secondary border-opacity-75 rounded-0 m-1" type="button">
                        //       <i className="bi bi-clipboard"></i> Precert
                        //     </button>
                        //   );
                        // case "Review":
                        //   return (
                        //     <button key={index} className="btn background-color-2 rounded-0 m-1" type="button">
                        //       <i className="bi bi-clipboard"></i> Review
                        //     </button>
                        //   );
                        // case "Appeal":
                        //   return (
                        //     <button key={index} className="btn btn-green background-color-3 rounded-0 m-1" type="button">
                        //       <i className="bi bi-clipboard"></i> Appeal
                        //     </button>
                        //   );
                        //   case "No Action Required":
                        //     return (
                        //       <p>No Action Required</p>
                        //     );

                        // default:
                        //   return (<span key={index}>{step}</span>);
                        else if (["review", "appeal"].includes(step.toLowerCase())) {
                          return (<></>);
                        } else {
                          return (<span key={index} className="text-black">{step}</span>);
                        }
                      })
                      : null}
                  </td>
                  {!isManufacturer &&
                    <><td className="align-middle">
                      <span className="btn btn-green text-nowrap rounded-0" onClick={() => navigateToModalAndPage(data)}>
                        <i className="fas fa-sync-alt"></i> Re-run
                      </span>
                    </td>
                    <td className="align-middle text-center fs-6" style={{ minWidth: '105px' }}>
                        {data.kam_fam_notes?.clickable && data.kam_fam_notes.text ? (
                          data.kam_fam_notes.text === 'Add Note' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {data.kam_fam_notes.text}
                            </button>
                          ) : data.kam_fam_notes.text === 'Confirm Indication' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {"Add Note"}
                            </button>
                          ) : 
                          // (!(String(data?.kam_fam_notes?.text ?? "").includes("No FAM Action Needed")) && !isManufacturer) ? (
                          //   <button
                          //     className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""}`}
                          //     onClick={() =>
                          //       setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                          //     }
                          //   >
                          //     {data.kam_fam_notes.text}
                          //   </button>
                          // ) : (<button
                          //   type="button"
                          //   className="btn btn-green btn-sm rounded-0"
                          //   onClick={() =>
                          //     setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                          //   }
                          // >
                          //   <i className="fas fa-times me-1"></i> Add Note
                          // </button>)
                          (isManufacturer || !String(data.kam_fam_notes?.text).includes("No FAM Action Needed"))
                                  ? (
                                    <button
                                      className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.bi_case_id
                                        })
                                      }
                                    >
                                      {data.kam_fam_notes?.text}
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-green btn-sm rounded-0"
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.bi_case_id
                                        })
                                      }
                                    >
                                      <i className="fas fa-times me-1"></i> Add Note
                                    </button>
                                  )
                        ) : (
                          // 'N/A'
                          <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {"Add Note"}
                            </button>
                        )}
                      </td>
                      </>
                  }
                  {isManufacturer && (
                    <>
                      <td className="align-middle text-center">
                         {data.pcc}
                       </td>
                       <td className="align-middle text-center">
                         {data.qns}
                       </td>
                        <td className="align-middle text-center">
                         {data.patient_actv_status}
                       </td>
                      <td className="align-middle">
                        {data.indication ? data.indication : 'N/A'}
                      </td>
                      {/* <td className="text-center align-middle fs-6">
                        {data.confirm_indication.clickable ?
                          <button
                            type="button" className="btn btn-success btn-sm rounded-0"
                            onClick={() => setDataForCancelIndication({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.bi_case_id })}
                          >
                            Confirm Indication
                          </button>
                          :
                          <p>{data.confirm_indication.text || "N/A"}</p>
                        }
                      </td> */}
                      {userData?.ref_type !== "rep" && <td className="align-middle text-center" style={{ minWidth: '105px' }}>
                        {data.kam_fam_notes?.clickable && data.kam_fam_notes.text ? (
                          data.kam_fam_notes.text === 'Add Note' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {data.kam_fam_notes.text}
                            </button>
                          ) : data.kam_fam_notes.text === 'Confirm Indication' ? (
                            <></>
                          ) : (
                            <button
                              className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              {data.kam_fam_notes.text}
                            </button>
                          )
                        ) : (
                          'N/A'
                        )}
                      </td>}
                    </>
                  )}
                </tr>
                )
              })
              : null}
          </tbody>
        </table>
      </div>

      {isManufacturer && (tableData && tableData.page_count && tableData.page_count > 1 ? (
        <div className="pagination pagination-sm pagination-lg justify-content-center flex-wrap mt-3">
          {currentPage !== 1 ? (
            <li className="page-item">
              <button className="btn btn-link page-link rounded-0" onClick={() => changePageNumber({ selected: 0 })}>
                <i className="bi bi-chevron-double-left"></i> First
              </button>
            </li>
          ) : null}

          <ReactPaginate
            nextLabel={<>Next <i className="bi bi-chevron-right"></i></>}
            onPageChange={changePageNumber}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={tableData.page_count}
            previousLabel={<><i className="bi bi-chevron-left"></i> Previous</>}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link rounded-0"
            nextClassName="page-item"
            nextLinkClassName="page-link rounded-0"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination pagination-sm pagination-lg"
            activeClassName="active"
            renderOnZeroPageCount={null}
            forcePage={currentPage - 1}
          />

          {currentPage !== tableData.page_count ? (
            <li className={`page-item ${currentPage === tableData.page_count ? 'disabled' : ''}`}>
              <button className="btn btn-link page-link rounded-0" onClick={() => changePageNumber({ selected: tableData.page_count - 1 })}>
                Last <i className="bi bi-chevron-double-right"></i>
              </button>
            </li>
          ) : null}
           <li className="page-item">
              <input
                type="number"
                min={1}
                max={tableData.page_count}
                className="form-control page-link"
                style={{ width: "67px" }}
                placeholder="Page"
                value={pageSearch}
                onChange={(e) => setPageSearch(e.target.value)}
                onBlur={handlePageSearch}          // 👈 Fire on focus out
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.currentTarget.blur();        // 👈 Trigger blur = auto jump
                  }
                }}
              />
            </li>
        </div>
      ) : null)}
      <ConfirmIndication
        isModalVisible={showCancelIndicationModal.isModalVisible}
        caseId={showCancelIndicationModal.caseId}
        prescriptionId={showCancelIndicationModal.prescriptionId}
        hideModal={() => {
          setDataForCancelIndication({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
      {showRequestTreatmentModal.isModalVisible && (
        <RequestDateOfTreatment
          isModalVisible={showRequestTreatmentModal.isModalVisible}
          caseId={showRequestTreatmentModal.caseId}
          prescriptionId={showRequestTreatmentModal.prescriptionId}
          bentype={showRequestTreatmentModal.bentype}
          investigated_at={showRequestTreatmentModal.investigated_at}
          hideModal={() => {
            setDataForRequestModalTreatment({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              bentype: "",
              investigated_at: ""
            });
          }}
          refreshListing={() => redirectDecision()}
        />
      )}

      {saveNoteModal.isModalVisible ? (
        <AddNote
          isModalVisible={saveNoteModal.isModalVisible}
          caseId={saveNoteModal.caseId}
          refreshListing={() => isManufacturer ? onActionPerformed() : redirectDecision()}
          hideModal={() => {
            setDataforNoteModal({
              isModalVisible: false,
              caseId: 0,
            });
          }}
        />
      ) : null}

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={cancelTreatmentModal.caseId}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
      <ReRunPatientModal
        isModalVisible={showReRunPatientModal.isModalVisible}
        caseId={showReRunPatientModal.caseId}
        prescriptionId={showReRunPatientModal.prescriptionId}
        bentype={showReRunPatientModal.bentype}
        title={showReRunPatientModal.title}
        investigated_at={showReRunPatientModal.investigated_at}
        hideModal={() => {
          setShowReRunPatientModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0,
            bentype: '',
            title: "",
            investigated_at: undefined
          });
        }}
        refreshListing={() => redirectDecision()}
      />
    </Fragment>
  );
};

export default SpecialityPharmacy;
